/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { monitoringControllerCreate } from '../fn/monitoring/monitoring-controller-create';
import { MonitoringControllerCreate$Params } from '../fn/monitoring/monitoring-controller-create';
import { monitoringControllerExportMonitorings } from '../fn/monitoring/monitoring-controller-export-monitorings';
import { MonitoringControllerExportMonitorings$Params } from '../fn/monitoring/monitoring-controller-export-monitorings';
import { monitoringControllerGetAll } from '../fn/monitoring/monitoring-controller-get-all';
import { MonitoringControllerGetAll$Params } from '../fn/monitoring/monitoring-controller-get-all';
import { monitoringControllerGetAllStatuses } from '../fn/monitoring/monitoring-controller-get-all-statuses';
import { MonitoringControllerGetAllStatuses$Params } from '../fn/monitoring/monitoring-controller-get-all-statuses';
import { monitoringControllerGetOne } from '../fn/monitoring/monitoring-controller-get-one';
import { MonitoringControllerGetOne$Params } from '../fn/monitoring/monitoring-controller-get-one';
import { monitoringControllerGetTimeline } from '../fn/monitoring/monitoring-controller-get-timeline';
import { MonitoringControllerGetTimeline$Params } from '../fn/monitoring/monitoring-controller-get-timeline';
import { monitoringControllerStatusWidget } from '../fn/monitoring/monitoring-controller-status-widget';
import { MonitoringControllerStatusWidget$Params } from '../fn/monitoring/monitoring-controller-status-widget';
import { monitoringControllerUpdate } from '../fn/monitoring/monitoring-controller-update';
import { MonitoringControllerUpdate$Params } from '../fn/monitoring/monitoring-controller-update';
import { MonitoringItem } from '../models/monitoring-item';
import { MonitoringItemList } from '../models/monitoring-item-list';
import { MonitoringStatusHistoryItemList } from '../models/monitoring-status-history-item-list';
import { MonitoringStatusItemList } from '../models/monitoring-status-item-list';
import { Number } from '../models/number';

@Injectable({ providedIn: 'root' })
export class MonitoringService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringControllerGetAll()` */
  static readonly MonitoringControllerGetAllPath = '/monitoring';

  /**
   * Ritorna tutti i monitoraggi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerGetAll$Response(params?: MonitoringControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItemList;
}>> {
    const obs = monitoringControllerGetAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna tutti i monitoraggi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerGetAll(params?: MonitoringControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MonitoringItemList;
}> {
    const resp = this.monitoringControllerGetAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItemList;
}>): BaseResponse & {
'data'?: MonitoringItemList;
} => r.body)
    );
  }

  /** Path part for operation `monitoringControllerCreate()` */
  static readonly MonitoringControllerCreatePath = '/monitoring';

  /**
   * Crea un monitoraggio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringControllerCreate$Response(params: MonitoringControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItem;
}>> {
    const obs = monitoringControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea un monitoraggio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringControllerCreate(params: MonitoringControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MonitoringItem;
}> {
    const resp = this.monitoringControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItem;
}>): BaseResponse & {
'data'?: MonitoringItem;
} => r.body)
    );
  }

  /** Path part for operation `monitoringControllerGetAllStatuses()` */
  static readonly MonitoringControllerGetAllStatusesPath = '/monitoring/statuses';

  /**
   * Ritorna l'elenco degli stati dei monitoraggi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringControllerGetAllStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerGetAllStatuses$Response(params?: MonitoringControllerGetAllStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringStatusItemList;
}>> {
    const obs = monitoringControllerGetAllStatuses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna l'elenco degli stati dei monitoraggi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringControllerGetAllStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerGetAllStatuses(params?: MonitoringControllerGetAllStatuses$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MonitoringStatusItemList;
}> {
    const resp = this.monitoringControllerGetAllStatuses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MonitoringStatusItemList;
}>): BaseResponse & {
'data'?: MonitoringStatusItemList;
} => r.body)
    );
  }

  /** Path part for operation `monitoringControllerStatusWidget()` */
  static readonly MonitoringControllerStatusWidgetPath = '/monitoring/status-widget';

  /**
   * Ritorna il numero dei monitoraggi per stato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringControllerStatusWidget()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerStatusWidget$Response(params: MonitoringControllerStatusWidget$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Number;
}>> {
    const obs = monitoringControllerStatusWidget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna il numero dei monitoraggi per stato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringControllerStatusWidget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerStatusWidget(params: MonitoringControllerStatusWidget$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: Number;
}> {
    const resp = this.monitoringControllerStatusWidget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: Number;
}>): BaseResponse & {
'data'?: Number;
} => r.body)
    );
  }

  /** Path part for operation `monitoringControllerExportMonitorings()` */
  static readonly MonitoringControllerExportMonitoringsPath = '/monitoring/export';

  /**
   * Esporta i monitoraggi filtrati in formato Excel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringControllerExportMonitorings()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerExportMonitorings$Response(params?: MonitoringControllerExportMonitorings$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = monitoringControllerExportMonitorings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Esporta i monitoraggi filtrati in formato Excel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringControllerExportMonitorings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerExportMonitorings(params?: MonitoringControllerExportMonitorings$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.monitoringControllerExportMonitorings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `monitoringControllerGetTimeline()` */
  static readonly MonitoringControllerGetTimelinePath = '/monitoring/{id}/timeline';

  /**
   * Restituisce la timeline del monitoraggio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringControllerGetTimeline()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerGetTimeline$Response(params: MonitoringControllerGetTimeline$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringStatusHistoryItemList;
}>> {
    const obs = monitoringControllerGetTimeline(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce la timeline del monitoraggio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringControllerGetTimeline$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerGetTimeline(params: MonitoringControllerGetTimeline$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MonitoringStatusHistoryItemList;
}> {
    const resp = this.monitoringControllerGetTimeline$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MonitoringStatusHistoryItemList;
}>): BaseResponse & {
'data'?: MonitoringStatusHistoryItemList;
} => r.body)
    );
  }

  /** Path part for operation `monitoringControllerGetOne()` */
  static readonly MonitoringControllerGetOnePath = '/monitoring/{id}';

  /**
   * Ritorna un monitoraggio per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerGetOne$Response(params: MonitoringControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItem;
}>> {
    const obs = monitoringControllerGetOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna un monitoraggio per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringControllerGetOne(params: MonitoringControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MonitoringItem;
}> {
    const resp = this.monitoringControllerGetOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItem;
}>): BaseResponse & {
'data'?: MonitoringItem;
} => r.body)
    );
  }

  /** Path part for operation `monitoringControllerUpdate()` */
  static readonly MonitoringControllerUpdatePath = '/monitoring/{id}';

  /**
   * Modifica un monitoraggio per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringControllerUpdate$Response(params: MonitoringControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItem;
}>> {
    const obs = monitoringControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Modifica un monitoraggio per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringControllerUpdate(params: MonitoringControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MonitoringItem;
}> {
    const resp = this.monitoringControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItem;
}>): BaseResponse & {
'data'?: MonitoringItem;
} => r.body)
    );
  }

}
